import { type MantineThemeOverride } from "@mantine/core";

const mantineTheme: MantineThemeOverride = {
  components: {
    Button: {
      defaultProps: {
        radius: "sm",
        size: "xs",
      },
    },
    TextInput: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600",
        input:
          "text-black h-10 data-[disabled=true]:bg-gray-100 data-[disabled=true]:text-gray-700 data-[disabled=true]:opacity-100",
      },
    },
    // Same look as TextInput: label style and description under the input.
    Autocomplete: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600",
        input:
          "text-black h-10 data-[disabled=true]:bg-gray-100 data-[disabled=true]:text-gray-700 data-[disabled=true]:opacity-100",
      },
    },
    Textarea: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600",
        input:
          "text-black h-10 data-[disabled=true]:bg-gray-100 data-[disabled=true]:text-gray-700 data-[disabled=true]:opacity-100",
      },
    },
    PasswordInput: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600",
        input: "text-black ",
      },
    },
    Select: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600 ",
        input: "text-black h-10 capitalize data-[disabled=true]:bg-gray-100 data-[disabled=true]:text-gray-700 data-[disabled=true]:opacity-100",
        dropdown: "capitalize",
      },
    },
    Modal: {
      classNames: {
        title: "!font-bold !text-xl text-black",
        header: "border-b-1 border-b-black/30",
        body: "!p-6",
        close: "!text-black !font-bold",
      },
    },
    Drawer: {
      classNames: {
        header: "border-b-1 border-b-black/30",
        title: "!font-bold !text-xl text-black",
        body: "py-4",
        overlay: "backdrop-blur-sm",
        close:
          "text-black font-bold border border-black rounded-full hover:bg-black hover:text-white transition-all duration-200",
      },
    },
    DateInput: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600",
        input: "text-black h-10 data-[disabled=true]:bg-gray-100 data-[disabled=true]:text-gray-700 data-[disabled=true]:opacity-100",
        calendarHeader: "bg-blue-50 rounded-t-md p-2",
        calendarHeaderLevel: "font-bold",
      },
    },
    NumberInput: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600",
        input: "text-black h-10 data-[disabled=true]:bg-gray-100 data-[disabled=true]:text-gray-700 data-[disabled=true]:opacity-100",
      },
    },
    MultiSelect: {
      defaultProps: {
        inputWrapperOrder: ['label', 'input', 'description', 'error'],
      },
      classNames: {
        label: "text-xs font-bold text-slate-600",
        input: "text-black h-10 data-[disabled=true]:bg-gray-100 data-[disabled=true]:text-gray-700 data-[disabled=true]:opacity-100",
      },
    },
    Checkbox: {
      classNames: {
        label: "text-sm font-medium text-slate-600 data-[disabled=true]:text-gray-500 data-[disabled=true]:opacity-100",
        input: "data-[disabled=true]:bg-gray-100 data-[disabled=true]:opacity-100",
      },
    },
    SegmentedControl: {
      classNames: {
        root: "border border-client-color/30",
        indicator: "bg-black shadow shadow-black/20",
        label: "font-bold text-black data-[active=true]:!text-white",
      },
    },
    Accordion: {
      classNames: {
        item: "rounded-lg border-client-color/15 border-2 ",
        chevron: "text-black font-bold",
        control:
          " font-bold text-black bg-client-color/15 hover:bg-client-color/15",
        panel: "pt-2 text-sm text-black",
        label: "font-bold ",
      },
    },
    NavLink: {
      classNames: {
        root: "rounded-lg data-[active=true]:!border-brand-50 data-[active=true]:!border",
      },
    },
    Table: {
      classNames: {
        table: "bg-white",
        th: "!font-bold text-base !bg-client-color/10 !backdrop-blur-sm !border-b-2 !border-b-client-color/50",
      },
    },
  },
};

export default mantineTheme;
